import "core-js/modules/es.array.slice";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { getMapKey } from '@/lib/utils';
var m = {
  namespaced: true,
  state: {
    recommend: {},
    letter: ''
  },
  mutations: {
    setRecommend: function setRecommend(state, _a) {
      var key = _a.key,
          list = _a.list;
      Vue.set(state.recommend, key, list);
    },
    setLetter: function setLetter(state, letter) {
      state.letter = letter;
    }
  },
  actions: {
    getRecommend: function getRecommend(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activity_id = _b.activity_id,
          number = _b.number;
      return __awaiter(this, void 0, void 0, function () {
        var params, res, rdata, key;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              params = {
                activity_id: activity_id
              };

              if (number) {
                Object.assign(params, {
                  number: number
                });
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/code_book/recommend', {
                params: params
              })];

            case 1:
              res = _c.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                key = getMapKey({
                  activity_id: activity_id,
                  number: number
                });
                commit('setRecommend', {
                  key: key,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getLetter: function getLetter(_a, activity_id) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/code_book/letter', {
                params: {
                  activity_id: activity_id
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setLetter', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    checkCode: function checkCode(context, _a) {
      var activity_id = _a.activity_id,
          code = _a.code,
          letter = _a.letter;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/code_book', {
                activity_id: activity_id,
                code: code.replaceAll(' ', '').slice(0, 5),
                letter: letter,
                from_path: location.href
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;